import { render, staticRenderFns } from "./Selector.vue?vue&type=template&id=d081a8fe&scoped=true&"
import script from "./Selector.vue?vue&type=script&lang=js&"
export * from "./Selector.vue?vue&type=script&lang=js&"
import style0 from "./Selector.vue?vue&type=style&index=0&id=d081a8fe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d081a8fe",
  null
  
)

export default component.exports